import React from "react";

type Size = "xs" | "sm" | "md" | "lg" | "xl";
type Tone = "primary" | "white" | "danger";

interface LoadingSpinnerProps {
  size?: Size;
  tone?: Tone;
  // Renders the spinner alone, without the centering wrapper. Use inside
  // buttons and other rows that do their own layout.
  bare?: boolean;
  // Margins only - never sizing or colour, which would collide with the
  // variant classes below and be resolved by stylesheet order, not prop order.
  className?: string;
}

const SIZE: Record<Size, string> = {
  xs: "h-4 w-4",
  sm: "h-5 w-5",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-12 w-12",
};

const TONE: Record<Tone, string> = {
  primary: "border-biafit-primary",
  white: "border-white",
  danger: "border-red-600 dark:border-red-400",
};

const WRAPPER_PADDING: Record<Size, string> = {
  xs: "py-2",
  sm: "py-3",
  md: "py-4",
  lg: "py-8",
  xl: "py-12",
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "xl",
  tone = "primary",
  bare = false,
  className = "",
}) => {
  const spinner = (
    <div
      role="status"
      aria-label="Loading"
      className={`animate-spin rounded-full border-b-2 ${SIZE[size]} ${
        TONE[tone]
      } ${bare ? className : ""}`}
    />
  );

  if (bare) return spinner;

  return (
    <div
      className={`flex items-center justify-center ${WRAPPER_PADDING[size]} ${className}`}
    >
      {spinner}
    </div>
  );
};

export default LoadingSpinner;
